<div class="progress-bar {{ type }}">
  <div class="icon {{ type }}">{{ level }}</div>

  <div class="inside-container {{ type }}">
    <div
      class="icon-backplate {{ type }}"
      *ngIf="smallProgressScale && progress > 0"
    ></div>
    <div
      class="scale-container {{ type }}"
      [ngClass]="{ smallProgressScale: smallProgressScale }"
    >
      <div class="energy" *ngIf="type === 'ENERGY'">{{ energy }}</div>
      <div class="scale {{ type }}" style.width="{{ progress + '%' }}"></div>
      <div class="preview-exp" *ngIf="previewExp !== undefined">
        + {{ previewExp }}
      </div>
      <div
        class="preview-progress"
        *ngIf="previewProgress"
        style.width="{{ previewProgress + '%' }}"
      ></div>
    </div>
  </div>
</div>
